export enum RoleEnum {
  None = 0,
  InstitutionAdmin = 1,    // Administrator ustanove
  MZOM = 2,                // Predstavnik MZOM
  ASOO = 3,                // Savjetnik ASOO
  Helpdesk = 4,            // Helpdesk
  InstitutionDirector = 5, // Ravnatelj ustanove
  ASOOAdmin = 6,           // Voditelj ASOO
  MZOMAdmin = 7,           // Voditelj MZOM
  ASOOOffice = 8,          // Pisarnica ASOO
  MZOMOffice = 9,          // Pisarnica MZOM
}
